import React from 'react'
import {Navbar} from '../Components/Navbar'
import {Footer} from '../Components/Footer'
export const Cart = () => {
  return (

      <div>
      <Navbar/>
      <h1>cart</h1>
    <Footer/>
      </div>
  )
}
